import AddToCartBase from "./add_to_cart_base";

export default class AddToCartProductPage extends AddToCartBase {
  initialize() {
    super.initialize();

    this.url = this.element.dataset.url;
    this.shoppingCartButton = document.querySelector(".js-add-to-cart-product-page");

    this.shoppingCartButton.addEventListener("click", () => {
      this.postUpdatedQuantity();
      this.updateQuantity();
    });
  }

  addQuantityEvent() {
    this.quantityElement.addEventListener("change", () => {
      if (this.quantityElement.value < this.inputMinThreshold || this.quantityElement.value == "") {
        this.quantityElement.value = this.inputMinThreshold;
      } else if (this.quantityElement.value > this.inputMaxThreshold) {
        this.quantityElement.value = this.inputMaxThreshold;
      }

      this.updateQuantity();

      this.plusButton.disabled = this.quantityElement.value >= this.inputMaxThreshold;
    });
  }

  updateQuantity() {
    this.minusButton.disabled = this.quantityElement.value <= this.inputMinThreshold;
  }
}
